import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { adminStore } from "@/store/admin";

export const routerBeforeEach = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const loginUser = adminStore();

  /**
   * 如果是未登录就获取登录态
   */
  if (loginUser.account === "") {
    await loginUser.getLoginUser();
  }

  // 如果目标路由需要权限校验
  if (to.meta.require) {
    if (loginUser.account !== "") {
      next();
    } else {
      next({ path: "/login" });
    }
  } else {
    // 如果不需要认证，直接访问
    next();
  }
};
